import { render } from "./AyudaSeleccion.vue?vue&type=template&id=649a63ef&scoped=true"
import script from "./AyudaSeleccion.vue?vue&type=script&lang=js"
export * from "./AyudaSeleccion.vue?vue&type=script&lang=js"

import "./AyudaSeleccion.vue?vue&type=style&index=0&id=649a63ef&lang=scss&scoped=true"

import exportComponent from "/Users/dracoghost/Documents/ProyectosFunkoPopMorelia/funkopopmorelia-catalogo-vue-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-649a63ef"]])

export default __exports__